import { render, staticRenderFns } from "./TypeEmail.vue?vue&type=template&id=6f170fb8"
import script from "./TypeEmail.vue?vue&type=script&lang=js"
export * from "./TypeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports